import {generateId} from "../../../../../../frontend-libs/random-id";

export default class InputField {
    constructor() {
        return {
            template: `
                <label class="label"
                       ng-class="{'-required': field.required}"
                       for="input-field-id_{{field.id}}">
                    {{field.label}}
                </label>
                <input class="field"
                       id="input-field-id_{{field.id}}" 
                       type="{{field.type || 'text'}}" 
                       ng-model="field.ngModel"
                       placeholder="{{field.placeholder}}"/>
                <div class="helpers">
                    <span class="hint" ng-if="field.hint">{{field.hint}}</span>
                    <span class="error" ng-if="field.error">{{field.error}}</span>
                    <a class="a-link -small" 
                        ng-if="field.link || field.linkClick"
                        ng-click="field.linkClick()"
                        href="{{field.link}}">
                            {{field.linkText}}
                    </a>
                </div>

            `,
            bindings: {
                type: '@',
                label: '@',
                placeholder: '@',
                required: '@',
                error: '@',
                hint: '@',
                link: '@',
                linkText: '@',
                linkClick: '&',
                ngModel: '='
            },
            controller: InputFieldCtrl,
            controllerAs: 'field'
        }
    }
}

class InputFieldCtrl {
    constructor(element) {
        this.id = generateId();
        this.$onInit = function () {
            element.addClass('m-input-field')
        };
    }
}

InputFieldCtrl.$inject = ['$element'];
